import { PDLButton, PDLTypography } from "../../../dna";
import ArrowUpRight from "@untitled-ui/icons-react/build/esm/ArrowUpRight";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "./index.scss";

const HomeArticles = () => (
  <Container fluid className="pdl_component_home_articles">
    <Row className="d-flex flex-row flex-nowrap gap-3">
      <Col xs={12} sm={6} className="flex-shrink-1">
        <Card className="h-100">
          <div
            className="cardImage card-img-top"
            style={{
              backgroundImage:
                "url(./images/generic/jurisprudencia_contratos.png)",
            }}
          ></div>
          <Card.Body className="p-4" style={{ cursor: 'pointer' }}>
            <a 
              href="http://plataforma.lex.com.br/doutrinas/69262d4e545eebbd36d61f25"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none text-reset d-block">
              <div className="d-flex flex-row flex-nowrap gap-3 align-items-top justify-content-between mb-1">
                <PDLTypography as="h5" display size="xs" weight="semibold">
                  Os Impactos da Tecnologia nas Relações Sociais e Empresariais
                </PDLTypography>
                <ArrowUpRight />
              </div>
              <PDLTypography size="md">
                Entenda as mudanças e principais decisões que afetam o ambiente
                corporativo.
              </PDLTypography>
            </a>
          </Card.Body>          
        </Card>
      </Col>
      <Col xs={12} sm={6} className="flex-shrink-1">
        <Card className="h-100">
          <a 
            href="http://plataforma.lex.com.br/doutrinas/69262d4e545eebbd36d61ef5"
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none text-reset"
            style={{ display: 'block', height: '100%' }}
          >
            <div
              className="cardImage card-img-top"
              style={{
                backgroundImage:
                  "url(./images/generic/reformas_legislativas.png)",
              }}
            ></div>
            <Card.Body className="p-4">
              <div className="d-flex flex-row flex-nowrap gap-3 align-items-top justify-content-between mb-1">
                <PDLTypography as="h5" display size="xs" weight="semibold">
                  As Novas Tecnologias e os Desafios do Direito do Consumidor
                </PDLTypography>
                <ArrowUpRight />
              </div>
              <PDLTypography size="md">
                Um resumo das principais alterações e como se preparar.
              </PDLTypography>
            </Card.Body>
          </a>
        </Card>
      </Col>
    </Row>
    <Row>
      <Col xs={12} className="text-center mt-5">
        <PDLButton variant="primary">Ver mais</PDLButton>
      </Col>
    </Row>
  </Container>
);

export default HomeArticles;
